import { getLocale } from '@ecomm/utils/locale/getLocale'
import { useExperience } from '@ninetailed/experience.js-react'
import {
  ComponentTypeEnum,
  type ExperienceConfiguration
} from '@ninetailed/experience.js-shared'
import * as A from 'fp-ts/lib/Array'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'
import { useMemo } from 'react'

import { getVariantIndexes } from './constants'

export const useIsODMONPreLaunchVariant = (
  mappedExperiences: readonly ExperienceConfiguration[]
) => {
  const locale = getLocale()

  const baseline = pipe(
    A.head([...mappedExperiences]),
    O.chain(experience =>
      pipe(
        A.head(experience.components),
        O.chain(comp =>
          comp.type === ComponentTypeEnum.EntryReplacement && comp.baseline
            ? O.fromNullable(comp.baseline)
            : O.none
        )
      )
    ),
    O.getOrElse(() => ({ id: '' }))
  )

  const experience = useExperience({
    baseline,
    experiences: [...mappedExperiences]
  })

  return useMemo(
    () =>
      locale === 'en-US' &&
      getVariantIndexes().some(idx => experience.variantIndex === idx),
    [experience.variantIndex, locale]
  )
}
